
document.addEventListener('DOMContentLoaded', function() {
  const phoneParagraph = document.querySelector('.footer .bls__footer-middle > .section-full > .row > div:last-child > .bls__footer_block-content > .bls__footer-infor > p');

  if (phoneParagraph) {
    const phoneText = phoneParagraph.textContent.replace('Phone:', '').trim();
    const phoneLink = document.createElement('a');
    phoneLink.href = `tel:${phoneText}`;
    phoneLink.textContent = phoneText;
    phoneParagraph.innerHTML = '';
    phoneParagraph.appendChild(phoneLink);
  } else {
    console.error('Phone paragraph element not found!');
  }


// Sidebar menu
  const menuLinks = document.querySelectorAll('.page-header .header-middle .mobile-menu-content li > a');
const currentUrl = window.location.pathname;

menuLinks.forEach(function(link) {
    const linkUrl = link.getAttribute('href');
    if (currentUrl === linkUrl) {
        link.classList.add('active--page');
    }
    
    console.log(linkUrl, 'linkUrl');
    const parentLi = link.closest('li.multicolumn_dropdown');
    if (parentLi) {
        parentLi.classList.add('active--page');
        const childLinks = parentLi.querySelectorAll('a');
        let hasActiveChild = false;
        
        childLinks.forEach(function(childLink) {
            if (childLink.classList.contains('active--page')) {
                hasActiveChild = true;
            }
        });
        if (!hasActiveChild) {
            parentLi.classList.remove('active--page');
        }
    }
});


const submenuDropdown = document.querySelectorAll('.page-header .header-middle .mobile-menu-content > ul.horizontal-list > li.multicolumn_dropdown');

submenuDropdown.forEach(function(index){
	index.addEventListener('click',function(){
		index.classList.toggle('active--toggle');
	})
})


  const collapsibleRows = document.querySelectorAll('.product--tab--item');

collapsibleRows.forEach((row) => {
  const title = row.querySelector('.bls__collapsible-title');

  title.addEventListener('click', () => {
    if (row.classList.contains('active--tab')) {
      row.classList.remove('active--tab');
    } else {
      collapsibleRows.forEach((item) => {
        item.classList.remove('active--tab');
      });
      row.classList.add('active--tab');
    }
  });
});

const socialIcon = document.querySelector('.social--links--section > .section-full > .row > div:nth-child(2) > .bls__section_shipping-inner');
const footerSocial = document.querySelector('.footer .bls__social-link');

const clonedFooterSocial = footerSocial.cloneNode(true);

socialIcon.appendChild(clonedFooterSocial);
  
});


